import { useEffect, useMemo, useRef, useState } from 'react'
import { useSlider } from 'react-use'

import SimpleSlider from '../reactSlider'
import { parseMilissecondsToMinutes } from '../../../../common/helpers/Strings'
import {
  UPDATE_AUDIO_SLIDER_VALUE,
  usePlayer
} from '../../context/player-context'

export default function AudioSlider() {
  const { contextState, dispatch } = usePlayer()

  const sliderRef = useRef(null)
  const { value } = useSlider(sliderRef)

  const [loopCount, setLoopCount] = useState(1)
  const [count, setCount] = useState(0)
  const [timeTrack, setTimeTrack] = useState(0)

  const totalTime = contextState.totalTime * 60

  const percentage = useMemo(
    () => Math.floor((contextState.audioOptions.time / totalTime) * 100),

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [contextState.audioOptions]
  )

  const time = useMemo(
    () => Math.floor(contextState.audioOptions.time),
    [contextState.audioOptions]
  )

  useEffect(() => {
    const restartButton = document.querySelector('.restart-button')

    restartButton.addEventListener('click', () => {
      setCount(0)
      setTimeTrack(0)
      contextState.audioControls.seek(0)
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const seekingTime = Math.floor(
      (Math.floor(contextState.audioSliderValue * 100) *
        Math.floor(contextState.audioOptions.duration)) /
        100
    )

    //seek audio to the appointed time
    contextState.audioControls.seek(seekingTime)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextState.audioSliderValue])

  useEffect(() => {
    value && dispatch({ type: UPDATE_AUDIO_SLIDER_VALUE, payload: value })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  useEffect(() => {
    setTimeTrack(timeTrack => timeTrack + 1)
  }, [time])

  useEffect(() => {
    setCount(count => count + 1)
  }, [percentage])

  useEffect(() => {
    contextState.audio.ref.current.onended = function () {
      if (loopCount < contextState.totalTime) {
        contextState.audioControls.play()
        setCount(count => count - 1)
        setTimeTrack(timeTrack => timeTrack - 1)
        setLoopCount(loopCount => loopCount + 1)
      }

      if (loopCount === contextState.totalTime) {
        contextState.audioControls.seek(0)
        setCount(0)
        setTimeTrack(0)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextState.audioOptions.time])

  return (
    <div className='react-slider position-relative w-100'>
      <SimpleSlider
        className='bg-white'
        sliderRef={sliderRef}
        sliderValue={count - 1}
      />
      <div className='audio-time-tracker mt-3 mx-1 d-flex justify-content-between text-white'>
        <span>{parseMilissecondsToMinutes(timeTrack - 1)}</span>
        <span>{parseMilissecondsToMinutes(totalTime)}</span>
      </div>
    </div>
  )
}
